import { useRouter } from "next/router";
import ProfileHeader from "~components/page-blocks/profile-header";
import { useEffect } from "react";
import useProfile from "~services/backend/profiles/useProfile";
import Sidebar from "~components/layout/sidebar";
import Widget from "~components/widget";
import P from "~ui/typography/p";
import LoginRequired from "~components/page-blocks/login-required";
import AllIcons from "~components/ui/all-icons";
import WidgetCarousel from "~components/WidgetCarousel";

const Profile = () => {
  const router = useRouter();
  const { replace, isReady } = router;

  const { profile } = useProfile();

  useEffect(() => {
    if (profile && isReady) {
      replace(`/${profile.username}`);
    }
  }, [profile, isReady]);

  return (
    <div>
      <div className="lg:hidden w-full mb-5">
        <Sidebar />
      </div>
      <ProfileHeader
        profile={profile}
        isMyProfile={profile}
        disableButtons={true}
      />
      <div className="flex flex-col lg:flex-row">
        <div className="hidden lg:block w-full lg:min-w-60 lg:w-60 mb-5 lg:mb-0">
          <Sidebar />
        </div>
        <div className="w-full flex flex-col items-start lg:flex-row relative">
          <div className="w-full lg:px-5">
            {profile ? (
              <div className="w-full min-h-[50vh] flex items-center justify-center mx-auto">
                <div className="w-full animate-pulse  flex items-center justify-center mx-auto">
                  <AllIcons name="LogoFull" className="w-48 text-zinc-900" />
                </div>
              </div>
            ) : (
              <LoginRequired />
            )}
          </div>
          <div className="w-full lg:w-[380px] shrink-0 sticky top-2 hidden lg:block">
            <Widget title="About Subclub" href="/about">
              <P className="@ftw font-medium @fts text-[14px] @ttc text-zinc-900">
                Subclub is a platform where creators can provide paid
                subscriptions for their fans, store files in an extensive cloud
                storage and get income in cryptocurrency.
              </P>
            </Widget>
            <WidgetCarousel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
